(function ($) {
  $("document").ready(($) => {
  const clientsImage = $('<div/>', {id: 'clients-image'});
  $("body").append(clientsImage);
  $('.clients a')
    .mouseover(function () {
      const that = $(this);
      const offset = that.offset();
      let css = {"top": 0};
      // check that the image not flows over the window
      if (offset.left + 300 > $(window).width()) {
        offset.left = $(window).width() - 340;
      }
      if (offset.top + 300 > $(window).height()) {
        offset.top = offset.top - 330;
        css = {bottom: 0};
      }

      clientsImage.append($("<img/>", {src: that.attr('href'), alt: that.text()}).css(css));
      clientsImage.css({
        left: (offset.left + 20),
        top: (offset.top + 25)
      });
      clientsImage.css({display: 'table-cell'});
    })
    .mouseout(function () {
      clientsImage.empty();
      clientsImage.hide();
    })
    .on('click', function (e) {
      e.preventDefault();
    });
  })
})(jQuery);
